import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {CustomObjectTypeSearchModel} from "../custom-object-type-search.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-custom-object-type-search-page",
    templateUrl: "./custom-object-type-search-page.component.html",
    providers: [provideSearchModel(CustomObjectTypeSearchModel), provideEntityModel(CustomObjectTypeEntityModel)]
})
export class CustomObjectTypeSearchPageComponent extends AbstractSearchPage {
}
